"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectToggleStyles = exports.selectCountStyles = exports.dropdownStyles = exports.selectStyles = void 0;
var styled_components_1 = require("styled-components");
var SelectXSmall = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-weight: 500;\n\theight: 22px;\n\tline-height: 22px;\n\tborder-radius: 2px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tfont-size: 12px;\n\t\theight: 26px;\n\t}\n"], ["\n\tfont-weight: 500;\n\theight: 22px;\n\tline-height: 22px;\n\tborder-radius: 2px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tfont-size: 12px;\n\t\theight: 26px;\n\t}\n"])));
var SelectSmall = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-weight: 500;\n\theight: 36px;\n\tline-height: 36px;\n"], ["\n\tfont-weight: 500;\n\theight: 36px;\n\tline-height: 36px;\n"])));
var SelectWidthSmall = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 120px;\n"], ["\n\twidth: 120px;\n"])));
var SelectMedium = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tfont-weight: 500;\n\theight: 40px;\n\tline-height: 40px;\n"], ["\n\tfont-weight: 500;\n\theight: 40px;\n\tline-height: 40px;\n"])));
var SelectWidthMedium = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 160px;\n"], ["\n\twidth: 160px;\n"])));
var SelectLarge = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tfont-weight: 500;\n\theight: 46px;\n\tline-height: 46px;\n"], ["\n\tfont-weight: 500;\n\theight: 46px;\n\tline-height: 46px;\n"])));
var SelectWidthLarge = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\twidth: 200px;\n"], ["\n\twidth: 200px;\n"])));
var SelectWidthXLarge = (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var SelectCountColor = (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tcolor: #999999;\n"], ["\n\tcolor: #999999;\n"])));
var DropdownWidthAuto = (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\twidth: auto;\n"], ["\n\twidth: auto;\n"])));
var DropdownWidthSmall = (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\twidth: 150px;\n"], ["\n\twidth: 150px;\n"])));
var DropdownWidthMedium = (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\twidth: 200px;\n"], ["\n\twidth: 200px;\n"])));
var DropdownWidthLarge = (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\twidth: 325px;\n"], ["\n\twidth: 325px;\n"])));
var DropdownWidthXLarge = (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var ToggleXSmall = (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\twidth: 14px;\n\tmax-width: 14px;\n\theight: 22px;\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 26px;\n\t}\n"], ["\n\twidth: 14px;\n\tmax-width: 14px;\n\theight: 22px;\n\ti {\n\t\tfont-size: 8px;\n\t}\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 26px;\n\t}\n"])));
var ToggleSmall = (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n\twidth: 24px;\n\tmax-width: 24px;\n\theight: 36px;\n\ti {\n\t\tfont-size: 9px;\n\t}\n"], ["\n\twidth: 24px;\n\tmax-width: 24px;\n\theight: 36px;\n\ti {\n\t\tfont-size: 9px;\n\t}\n"])));
var ToggleMedium = (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\twidth: 27px;\n\tmax-width: 27px;\n\theight: 40px;\n\ti {\n\t\tfont-size: 10px;\n\t}\n"], ["\n\twidth: 27px;\n\tmax-width: 27px;\n\theight: 40px;\n\ti {\n\t\tfont-size: 10px;\n\t}\n"])));
var ToggleLarge = (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n\twidth: 32px;\n\tmax-width: 32px;\n\theight: 46px;\n\ti {\n\t\tfont-size: 10px;\n\t}\n"], ["\n\twidth: 32px;\n\tmax-width: 32px;\n\theight: 46px;\n\ti {\n\t\tfont-size: 10px;\n\t}\n"])));
function selectStyles(size, selectSize) {
    var styles = SelectMedium;
    switch (size) {
        case 'xs':
            styles = SelectXSmall;
            break;
        case 'sm':
            styles = SelectSmall;
            break;
        case 'md':
            styles = SelectMedium;
            break;
        case 'lg':
            styles = SelectLarge;
            break;
    }
    switch (selectSize) {
        case 'sm':
            return "".concat(styles, " ").concat(SelectWidthSmall);
        case 'md':
            return "".concat(styles, " ").concat(SelectWidthMedium);
        case 'lg':
            return "".concat(styles, " ").concat(SelectWidthLarge);
        case 'xlg':
            return "".concat(styles, " ").concat(SelectWidthXLarge);
    }
    return styles;
}
exports.selectStyles = selectStyles;
function dropdownStyles(dropdownSize) {
    switch (dropdownSize) {
        case 'sm':
            return DropdownWidthSmall;
        case 'md':
            return DropdownWidthMedium;
        case 'lg':
            return DropdownWidthLarge;
        case 'xlg':
            return DropdownWidthXLarge;
        default:
            return DropdownWidthAuto;
    }
    return '';
}
exports.dropdownStyles = dropdownStyles;
function selectCountStyles(size) {
    switch (size) {
        case 'sm':
            return "".concat(SelectSmall, "\n                ").concat(SelectCountColor);
        case 'lg':
            return "".concat(SelectLarge, "\n\t\t\t\t").concat(SelectCountColor);
        default:
            return "".concat(SelectMedium, "\n\t\t\t\t").concat(SelectCountColor);
    }
}
exports.selectCountStyles = selectCountStyles;
function selectToggleStyles(size) {
    switch (size) {
        case 'xs':
            return ToggleXSmall;
        case 'sm':
            return ToggleSmall;
        case 'lg':
            return ToggleLarge;
        default:
            return ToggleMedium;
    }
}
exports.selectToggleStyles = selectToggleStyles;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
